import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { ColumnsTableModalSelect } from '@app/shared';
import {
  BaseControl,
  Textbox,
  Radio,
  Dropdown,
  TextArea,
  Typeahead,
  DateTimePicker,
  Custom,
  Legend,
  Container,
  ModalSelect
} from '@app/shared/dynamic-form';

@Injectable()
export class BasicFormService {

  municipalities = [
    {
      id: 1,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Medellin'
    },
    {
      id: 2,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Bello'
    },
    {
      id: 3,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Itagui'
    },
    {
      id: 4,
      country: 'Colombia',
      department: 'Cundinamarca',
      municipalities: 'Zipaquirá'
    },
    {
      id: 5,
      country: 'Colombia',
      department: 'Cundinamarca',
      municipalities: 'Soacha'
    },
    {
      id: 6,
      country: 'Colombia',
      department: 'Cundinamarca',
      municipalities: 'Ubate'
    },
    {
      id: 7,
      country: 'Colombia',
      department: 'Atlantico',
      municipalities: 'Barranquilla'
    },
    {
      id: 8,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Abejorral'
    },
    {
      id: 9,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Amagá'
    },
    {
      id: 10,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Amalfi'
    },
    {
      id: 11,
      country: 'Colombia',
      department: 'Antioquia',
      municipalities: 'Caldas'
    },
  ];

  columnsSelect: Array<ColumnsTableModalSelect> = [
    {
      key: 'department',
      label: 'Departamento'
    },
    {
      key: 'municipalities',
      label: 'Municipio'
    },
  ];

  constructor() {}

  getFields(objectModel?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Container({
        class: 'form-row',
        order: 1,
        controls: [
          new Textbox({
            key: 'email',
            type: 'email',
            label: 'Email address:',
            size: 'col-12 col-lg-6',
            placeholder: 'name@example.com',
            describe: 'Well never share your email with anyone else.',
            value: objectModel ? objectModel.email : null,
            validations: {
              validators: [Validators.required, Validators.email],
              messages: {
                required: 'Es necesario el email.',
                email: 'Porfa introduce un email válido.'
              }
            }
          }),
          new Textbox({
            key: 'password',
            type: 'password',
            label: 'Password:',
            size: 'col-12 col-lg-6',
            placeholder: 'Password',
            value: objectModel ? objectModel.password : null,
            validations: {
              validators: [Validators.required]
            }
          })
        ]
      }),

      new Legend({
        value: 'Checkbox:',
        order: 2
      }),

      new Container({
        class: 'form-row form-check form-check-inline',
        order: 3,
        controls: [
          new Textbox({
            key: 'checkme',
            type: 'checkbox',
            label: 'Check me out 1',
            class: {
              container: ['pl-1']
            },
            value: objectModel ? objectModel.checkme : null,
            validations: {
              validators: [Validators.required]
            }
          }),
          new Textbox({
            key: 'checkme2',
            type: 'checkbox',
            label: 'Check me out 2',
            value: objectModel ? objectModel.checkme2 : null,
            validations: {
              validators: [Validators.required]
            }
          })
        ]
      }),

      new Radio({
        key: 'gender',
        type: 'radio',
        label: 'Gender:',
        labels: ['male', 'female', 'other'],
        values: ['male', 'female', 'other'],
        class: {
          container: ['form-check', 'form-check-inline']
        },
        value: objectModel ? objectModel.gender : null,
        order: 4,
        validations: {
          validators: [Validators.required]
        }
      }),

      new Dropdown({
        key: 'select',
        label: 'Example select:',
        options: [{ key: '1', value: 'Uno' }, { key: '2', value: 'Dos' }, { key: '3', value: 'Tres' }],
        value: objectModel ? objectModel.select : null,
        order: 5,
        validations: {
          validators: [Validators.required]
        }
      }),

      new TextArea({
        key: 'textarea',
        label: 'Example textarea:',
        rows: '2',
        notResize: true,
        value: objectModel ? objectModel.textarea : null,
        order: 6,
        validations: {
          validators: [Validators.required, Validators.minLength(5), Validators.maxLength(100)]
        }
      }),

      new TextArea({
        key: 'textarea_readonly',
        label: 'Example textarea(readonly):',
        rows: '2',
        notResize: true,
        readonly: true,
        value: objectModel ? objectModel.textarea_readonly : null,
        order: 6,
        validations: {
          validators: [Validators.required, Validators.minLength(5), Validators.maxLength(100)]
        }
      }),

      new Container({
        class: 'form-row',
        order: 7,
        controls: [
          new Textbox({
            key: 'file',
            label: 'Example file',
            type: 'file',
            size: 'col-12 col-lg-12'
          }),
          new Textbox({
            key: 'readonly_plaintext',
            type: 'text',
            label: 'Readonly plaintext:',
            size: 'col-12 col-lg-12',
            class: {
              label: ['col-form-label', 'text-danger'],
              input: ['form-control-plaintext']
            },
            value: 'Texto plano.'
          }),
          new Textbox({
            key: 'textbox_disabled',
            label: 'Control disabled:',
            size: 'col-12 col-lg-12',
            disabled: true,
            validations: {
              validators: [Validators.required]
            }
          })
        ]
      }),

      new Typeahead({
        key: 'typeahead',
        label: 'Typeahead:',
        order: 10,
        placeholder: 'Selecciona un país',
        data: objectModel.dataTypeahead,
        typeaheadMinLength: 0,
        // typeaheadOptionsLimit: objectModel.dataTypeahead.length,
        typeaheadScrollable: true,
        typeaheadOptionsInScrollableView: 7,
        validations: {
          validators: []
        }
      }),
      new DateTimePicker({
        key: 'dpicker',
        label: 'DatePicker:',
        order: 11,
        value: new Date(),
        pickerMode: 'dialog',
        pickerType: 'calendar',
        placeholder: 'Seleccione una fecha',
        minDate: new Date(),
        maxDate: new Date(2018, 2, 15),
        validations: {
          validators: [Validators.required]
        }
      }),

      new DateTimePicker({
        key: 'tpicker',
        label: 'TimerPicker:',
        order: 11,
        pickerType: 'timer',
        placeholder: 'Seleccione una hora',
        validations: {
          validators: [Validators.required]
        }
      }),

      new Container({
        class: 'form-row',
        order: 12,
        controls: [
          new DateTimePicker({
            key: 'dpicker2',
            label: 'DateTimePicker:',
            size: 'col-12 col-lg-4',
            placeholder: 'Seleccione una fecha y hora',
            validations: {
              validators: [Validators.required]
            }
          }),
          new DateTimePicker({
            key: 'rpicker',
            label: 'RangePicker:',
            size: 'col-12 col-lg-4',
            selectMode: 'range',
            placeholder: 'Seleccione el rango de fechas',
            validations: {
              validators: [Validators.required]
            }
          }),
          new DateTimePicker({
            key: 'rdtpicker',
            label: 'RangeDatePicker:',
            size: 'col-12 col-lg-4',
            selectMode: 'range',
            pickerMode: 'dialog',
            pickerType: 'calendar',
            placeholder: 'Seleccione el rango de fechas',
            validations: {
              validators: [Validators.required]
            }
          })
        ]
      }),

      new Container({
        class: 'form-row',
        order: 13,
        controls: [
          new DateTimePicker({
            key: 'rtpicker',
            label: 'RangeTimerPicker:',
            order: 13,
            size: 'col-12 col-lg-6',
            selectMode: 'range',
            pickerMode: 'dialog',
            pickerType: 'timer',
            placeholder: 'Seleccione el rango de horas',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'ngSelect',
            label: 'Control personalizado(ng-select):',
            order: 14,
            size: 'col-12 col-lg-6',
            template: objectModel.ngSelectTpl,
            placeholder: 'ng-select con ng-template',
            validations: {
              validators: [Validators.required]
            }
          })
        ]
      }),
      new ModalSelect({
        key: 'modalSelect',
        label: 'Select en modal:',
        order: 15,
        placeholder: 'Seleccione un registro de la modal',
        describe: 'Selector con modal',
        value: objectModel ? objectModel.modalSelect : null,
        validations: {
          validators: [Validators.required, Validators.email]
        },
        data: this.municipalities,
        columns: this.columnsSelect,
        keyValue: 'id',
        classModal: 'modal-lg-personalized',
        class: 'form-control',
        actionAdd: true,
        actionUpdate: true,
        actionDelete: true,
      }),
      new Textbox({
        key: 'textbox_disabled',
        label: 'Control disabled:',
        order: 15,
        type: 'number',
        customDecimalMax: 5,
        customMax: 50,
        customMin: 15,
        size: 'col-12 col-lg-12',
        validations: {
          validators: [Validators.required],
          messages: {
            customDecimalMax: 'Maximo 5 decimales',
            customMax: 'Numeros menores a 50',
            customMin: 'Numeros mayores a 15',
          }
        }
      }),
    ];

    // Ordenar los campos segun su propiedad order
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/forms/shared/basic-form.service.ts